export default {
	'health-certificates': 'Certificados de salud',
    'health-certificate': 'Certificado de salud',
    'add-a-health-certificate': 'Agregar certificado de salud'
}